const t = {
  de: {
    // Header
    nav_argumente: "Argumente",
    nav_veranstaltungen: "Veranstaltungen",
    nav_kontakt: "Kontakt",
    nav_newsletter: "Newsletter",
    header_cta: "Erstgespräch vereinbaren",

    // Hero
    hero_tag: "Vermögensschutz mit Edelmetallen",
    hero_h1_1: "Ihr Geld verliert.",
    hero_h1_2: "Jeden Tag. Still. Unbemerkt.",
    hero_sub: "Physische Edelmetalle sind die einzige Anlageklasse, die gleichzeitig Kaufkraft erhält, steuerfrei wächst, sofort liquidierbar ist und Ihr Vermögen außerhalb des Bankensystems schützt.",
    hero_cta: "Kostenloses Erstgespräch vereinbaren",
    hero_quote: "\u201EDer beste Zeitpunkt, Verm\u00F6gen zu sch\u00FCtzen, war gestern. Der n\u00E4chstbeste ist heute.\u201C",

    // Arguments
    args_tag: "Warum Edelmetalle",
    args_h2: "4 unschlagbare Argumente",
    arg1_title: "Kaufkraft erhalten & Inflation schlagen",
    arg1_text: "Der Euro hat seit 2000 rund 45 % seiner Kaufkraft verloren. Gold legte im selben Zeitraum +1.400 % zu — von 262 €/oz auf heute ca. 4.000 €/oz. Wer spart, verliert. Wer in Edelmetalle investiert, erhält reale Werte über Generationen.",
    arg1_hl: "+1.400 %",
    arg2_title: "Bankenunabhängig & vor staatlichem Zugriff geschützt",
    arg2_text: "Ihr Edelmetall wird auf Ihren Namen & Ihre Rechnung im Schweizer Zollfreilager gelagert — außerhalb der EU, außerhalb des Bankensystems. Kein Gegenparteirisiko. Kein Bail-in. Kein staatlicher Zugriff. Insolvenzschutz.",
    arg2_hl: "Schweizer Zollfreilager",
    arg3_title: "Steuerfrei kaufen & Gewinne steuerfrei vereinnahmen",
    arg3_text: "Physische Edelmetalle im Zollfreilager: 0 % Mehrwertsteuer beim Kauf. Kursgewinne nach 12 Monaten: 0 % Abgeltungssteuer (§ 23 EStG). Kein anderes liquides Anlageinstrument bietet diesen legalen Steuervorteil — auch für Silber, Platin & Palladium.",
    arg3_hl: "0 % Steuer",
    arg4_title: "Liquider Wertspeicher — jederzeit verfügbar",
    arg4_text: "Ihr Edelmetall-Depot ist kein gebundenes Kapital. Wertstand jederzeit einsehbar. Verkauf oder physische Auslieferung jederzeit möglich. Standardformate (1 oz – 1 kg) sichern sofortige Marktgängigkeit.",
    arg4_hl: "Jederzeit verfügbar",

    // Events
    events_tag: "Termine",
    events_h2: "Veranstaltungskalender",
    events_register: "Anmelden",
    events_reg_title: "Anmeldung",
    events_reg_name: "Name *",
    events_reg_email: "E-Mail *",
    events_reg_phone: "Telefon",
    events_reg_message: "Nachricht",
    events_reg_submit: "Jetzt anmelden",
    events_reg_sending: "Wird gesendet...",
    events_reg_success_title: "Anmeldung erfolgreich!",
    events_reg_success_text: "Eine Bestätigungsmail wurde an Ihre E-Mail-Adresse gesendet.",
    events_reg_cancel: "Abbrechen",
    events_reg_close: "Schließen",

    // Contact
    contact_tag: "Kontakt",
    contact_h2: "Jetzt Erstgespräch vereinbaren",
    contact_name: "Name *",
    contact_email: "E-Mail *",
    contact_phone: "Telefon",
    contact_message: "Nachricht *",
    contact_submit: "Nachricht senden",
    contact_sending: "Wird gesendet...",
    contact_success_title: "Nachricht gesendet!",
    contact_success_text: "Wir melden uns in Kürze bei Ihnen.",
    contact_another: "Weitere Nachricht senden",
    contact_direct: "Direkter Kontakt",
    contact_phone_label: "Telefon",
    contact_email_label: "E-Mail",
    contact_whatsapp_label: "WhatsApp",
    contact_qr_title: "WhatsApp QR-Code scannen",
    contact_qr_text: "Scannen Sie den Code mit Ihrem Smartphone",

    // Newsletter
    nl_h2: "Newsletter abonnieren",
    nl_sub: "Erhalten Sie aktuelle Informationen zu Edelmetallen und Veranstaltungen.",
    nl_formal: "Formelle Anrede (Sie)",
    nl_informal: "Persönliche Anrede (Du)",
    nl_title: "Titel",
    nl_firstname: "Vorname *",
    nl_lastname: "Nachname *",
    nl_email: "E-Mail *",
    nl_topics: "Themen auswählen *",
    nl_topic_general: "Allgemeiner Newsletter",
    nl_topic_general_desc: "Marktanalysen, Edelmetall-Tipps, Unternehmensnews",
    nl_topic_events: "Ankündigung neue Veranstaltungen",
    nl_topic_events_desc: "Einladungen zu Seminaren, Stammtischen, Events",
    nl_privacy: "Mit der Anmeldung erklären Sie sich mit unserer",
    nl_privacy_link: "Datenschutzerklärung",
    nl_privacy_end: "einverstanden. Sie können sich jederzeit abmelden.",
    nl_submit: "Newsletter abonnieren",
    nl_success_title: "Bestätigungsmail gesendet!",
    nl_success_text: "Bitte prüfen Sie Ihren Posteingang und klicken Sie auf den Bestätigungslink.",
    nl_error_topics: "Bitte wählen Sie mindestens ein Thema aus.",

    // Partners
    partners_tag: "Partnerschaften",
    partners_h2: "VMBS UG ist Exklusivpartner von",

    // Footer
    footer_tagline: "Vermögen mit Bedacht sichern",
    footer_impressum: "Impressum",
    footer_datenschutz: "Datenschutzerklärung",

    // Cookie
    cookie_text: "Diese Website benutzt technisch bedingte Cookies.",
    cookie_more: "Mehr erfahren",
    cookie_ok: "OK",
  },

  en: {
    // Header
    nav_argumente: "Why Precious Metals",
    nav_veranstaltungen: "Events",
    nav_kontakt: "Contact",
    nav_newsletter: "Newsletter",
    header_cta: "Book Appointment",

    // Hero
    hero_tag: "Wealth Protection with Precious Metals",
    hero_h1_1: "Your money is losing value.",
    hero_h1_2: "Every day. Silently. Unnoticed.",
    hero_sub: "Physical precious metals are the only asset class that simultaneously preserves purchasing power, grows tax-free, is instantly liquidatable, and protects your wealth outside the banking system.",
    hero_cta: "Book a Free Appointment",
    hero_quote: "\u201CThe best time to protect your wealth was yesterday. The next best time is today.\u201D",

    // Arguments
    args_tag: "Why Precious Metals",
    args_h2: "4 Compelling Arguments",
    arg1_title: "Preserve Purchasing Power & Beat Inflation",
    arg1_text: "The Euro has lost approximately 45% of its purchasing power since 2000. Gold increased by +1,400% in the same period — from €262/oz to approximately €4,000/oz today. Those who save, lose. Those who invest in precious metals preserve real value across generations.",
    arg1_hl: "+1,400%",
    arg2_title: "Bank-Independent & Protected from Government Access",
    arg2_text: "Your precious metals are stored in your name and at your expense in a Swiss duty-free warehouse — outside the EU, outside the banking system. No counterparty risk. No bail-in. No government access. Insolvency protection.",
    arg2_hl: "Swiss Duty-Free Vault",
    arg3_title: "Buy Tax-Free & Realize Tax-Free Gains",
    arg3_text: "Physical precious metals in duty-free storage: 0% VAT on purchase. Capital gains after 12 months: 0% capital gains tax (§23 EStG). No other liquid investment instrument offers this legal tax advantage — also for silver, platinum & palladium.",
    arg3_hl: "0% Tax",
    arg4_title: "Liquid Store of Value — Available Anytime",
    arg4_text: "Your precious metals portfolio is not tied-up capital. Asset value visible at any time. Sale or physical delivery possible at any time. Standard formats (1 oz – 1 kg) ensure immediate marketability.",
    arg4_hl: "Available Anytime",

    // Events
    events_tag: "Dates",
    events_h2: "Events Calendar",
    events_register: "Register",
    events_reg_title: "Registration",
    events_reg_name: "Name *",
    events_reg_email: "Email *",
    events_reg_phone: "Phone",
    events_reg_message: "Message",
    events_reg_submit: "Register Now",
    events_reg_sending: "Sending...",
    events_reg_success_title: "Registration Successful!",
    events_reg_success_text: "A confirmation email has been sent to your email address.",
    events_reg_cancel: "Cancel",
    events_reg_close: "Close",

    // Contact
    contact_tag: "Contact",
    contact_h2: "Book Your Free Appointment",
    contact_name: "Name *",
    contact_email: "Email *",
    contact_phone: "Phone",
    contact_message: "Message *",
    contact_submit: "Send Message",
    contact_sending: "Sending...",
    contact_success_title: "Message Sent!",
    contact_success_text: "We will get back to you shortly.",
    contact_another: "Send Another Message",
    contact_direct: "Direct Contact",
    contact_phone_label: "Phone",
    contact_email_label: "Email",
    contact_whatsapp_label: "WhatsApp",
    contact_qr_title: "Scan WhatsApp QR Code",
    contact_qr_text: "Scan the code with your smartphone",

    // Newsletter
    nl_h2: "Subscribe to Newsletter",
    nl_sub: "Receive the latest information on precious metals and events.",
    nl_formal: "Formal address (Sie)",
    nl_informal: "Informal address (Du)",
    nl_title: "Title",
    nl_firstname: "First Name *",
    nl_lastname: "Last Name *",
    nl_email: "Email *",
    nl_topics: "Select Topics *",
    nl_topic_general: "General Newsletter",
    nl_topic_general_desc: "Market analyses, precious metal tips, company news",
    nl_topic_events: "Event Announcements",
    nl_topic_events_desc: "Invitations to seminars, meetups, events",
    nl_privacy: "By subscribing you agree to our",
    nl_privacy_link: "Privacy Policy",
    nl_privacy_end: ". You can unsubscribe at any time.",
    nl_submit: "Subscribe to Newsletter",
    nl_success_title: "Confirmation Email Sent!",
    nl_success_text: "Please check your inbox and click the confirmation link.",
    nl_error_topics: "Please select at least one topic.",

    // Partners
    partners_tag: "Partnerships",
    partners_h2: "VMBS UG is Exclusive Partner of",

    // Footer
    footer_tagline: "Securing Wealth with Foresight",
    footer_impressum: "Legal Notice",
    footer_datenschutz: "Privacy Policy",

    // Cookie
    cookie_text: "This website uses technically necessary cookies.",
    cookie_more: "Learn more",
    cookie_ok: "OK",
  },
};

export default t;
